<template>
  <span
    class="vx-badge"
    :class="classes"
  >
    <template v-if="content">{{ content }}</template>
    <slot/>
    <span class="vx-badge__wrapper">
      <span class="vx-badge__badge"
            :style="styles"></span>
    </span>
  </span>
</template>

<script>

export default {
  name: 'VBadge',
  props: {
    bordered: Boolean,
    color: {
      type: String,
      default: 'primary',
    },
    content: {required: false},
    dot: Boolean,
    label: {
      type: String,
    },
    icon: String,
    inline: Boolean,
    left: Boolean,
    bottom: {
      type: Boolean,
    },
    button: Boolean,
    offsetX: {
      type: [Number, String],
      default: 4,
    },
    offsetY: {
      type: [Number, String],
      default: 4,
    },
    overlap: Boolean,
    tile: Boolean,
    value: {default: true},
  },
  computed: {
    classes() {
      return {
        'vx-badge--bordered': this.bordered,
        'vx-badge--bottom': this.bottom,
        'vx-badge--dot': this.dot,
        'vx-badge--icon': this.icon != null,
        'vx-badge--inline': this.inline,
        'vx-badge--left': this.left,
        'vx-badge--overlap': this.overlap,
        'vx-badge--tile': this.tile,
      }
    },
    styles() {
      return {
        inset: `${this.computedTop} ${this.computedRight} ${this.computedBottom} ${this.computedLeft}`,
        'background-color': this.color ? `var(--vx-${this.color})` : '',
      };
    },
    computedBottom() {
      return this.bottom ? 'auto' : this.computedYOffset
    },
    computedLeft() {
      return this.left ? 'auto' : this.computedXOffset
    },
    computedRight() {
      return !this.left ? 'auto' : this.computedXOffset
    },
    computedTop() {
      return this.bottom ? this.computedYOffset : 'auto'
    },
    computedXOffset() {
      return this.calcPosition(this.offsetX)
    },
    computedYOffset() {
      return this.calcPosition(this.offsetY)
    },
  },
  methods: {
    calcPosition(offset) {
      return `calc(100% - ${(offset || this.offset)}px)`
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VBadge";
</style>
